import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Paperclip, DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

// Small pill showing an attached file inside a message bubble. Lazy-fetches the
// filename so the label matches what the admin/customer sees elsewhere.
export default function MessageAttachment({ fileId }) {
  const [meta, setMeta] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/files/${fileId}`);
        if (!cancelled) setMeta(data);
      } catch { if (!cancelled) setMeta({ original_filename: null }); }
    })();
    return () => { cancelled = true; };
  }, [fileId]);

  const label = meta?.original_filename || `asset-${fileId.slice(0, 8)}`;

  const download = async (e) => {
    e.preventDefault();
    setDownloading(true);
    try {
      const r = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = label;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      toast.error("Couldn't download attachment");
    } finally { setDownloading(false); }
  };

  return (
    <a
      href="#"
      onClick={download}
      className="inline-flex items-center gap-1.5 text-xs px-2 py-1 border border-[var(--gc-navy)] bg-white text-[var(--gc-navy)] hover:bg-[var(--gc-bg-alt)] font-mono-tech max-w-full"
      title={label}
      data-testid={`msg-attachment-${fileId}`}
    >
      <Paperclip size={12} weight="bold"/>
      <span className="truncate max-w-[220px]">{label}</span>
      <DownloadSimple size={12} weight="bold" className="shrink-0 opacity-60"/>
      {downloading && <span className="tech-label ml-1">…</span>}
    </a>
  );
}
